export default __webpack_public_path__ + "static/media/unlock.ac9001a0.svg";